import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export function formatTimeAgo(dateString: string) {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) return Math.floor(interval) + ' tahun lalu';
  interval = seconds / 2592000;
  if (interval > 1) return Math.floor(interval) + ' bulan lalu';
  interval = seconds / 86400;
  if (interval > 1) return Math.floor(interval) + ' hari lalu';
  interval = seconds / 3600;
  if (interval > 1) return Math.floor(interval) + ' jam lalu';
  interval = seconds / 60;
  if (interval > 1) return Math.floor(interval) + ' menit lalu';
  return 'Baru saja';
}

export function stripHtml(html: string | undefined | null) {
  if (!html) return '';

  // If running in browser, use DOM parser for accurate entity decoding
  if (typeof document !== 'undefined') {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  // Fallback for non-browser environments (like Node.js scripts)
  return html
    .replace(/<[^>]+>/g, '') // Remove tags
    .replace(/&nbsp;/g, ' ') // Replace non-breaking space
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .trim();
}
